import { render, staticRenderFns } from "./MatrixCalculationQuestion.vue?vue&type=template&id=49bf5eb1&scoped=true"
import script from "./MatrixCalculationQuestion.vue?vue&type=script&lang=js"
export * from "./MatrixCalculationQuestion.vue?vue&type=script&lang=js"
import style0 from "./MatrixCalculationQuestion.vue?vue&type=style&index=0&id=49bf5eb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bf5eb1",
  null
  
)

export default component.exports